import React from "react";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import KnowledgeMainBannerImage from "../../../../styles/img/knowl-dashboard-banner.png";
import KnowledgeBaner from "./Views/KnowledgeBanner";
import { UiBannerBottomBar } from "../../components/common/UiBannerBottomBar";
import { UiContentCol, UiContentWr } from "../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer";
import UiHowCampaignsWork from "../../components/common/UiHowCampaignsWork";
import { KnowledgeProgress } from "./Views/KnowledgeProgress";
import { KnowledgeLatestPrograms } from "./Views/KnowledgeLatestPrograms";
import { KnowledgeMonthlyPoints } from "./Views/KnowledgeMonthlyPoints";
import { KnowledgePhotos } from "./Views/KnowledgePhotos";
import { KnowledgeHowToEarn } from "./Views/KnowledgeHowToEarn";
import Footer from "../../components/footer/Footer";
import HowKnowledgeWork from "./Views/HowKnowledgeWork"
import PostCard from "./Views/PostCard"
import { UiCardTitle } from "../../components/common/UiCardTitle";
import {KnowledgeProgressV2} from "./Views/KnowledgeProgressV2"



export const BadgesDashboard = () => {
    return (
        <>
            <UiMainWrapper>
                <TopHeader />

                <KnowledgeBaner
                    topText="Knowledge"
                    title="Learn About Volvo
                    101 - It's basics."
                    description="lorem epsum text dandom text knowledge lorem epsum text dandom text knowledge skills"
                    sliderCardImage={KnowledgeMainBannerImage}
                    buttonSet={true}
                    className="knowl-banner"   />                 
                                   
                <UiBannerBottomBar
                    prevPage="Knowledge"
                    prevPageLink="/ui"
                    currentPage="  Learn About Volvo 101 - It's basics"
                    currentPageLink="/ui/incentives-pre-register"
                />

                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="12">
                            <UiContentCol>
                                <HowKnowledgeWork />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

              {/* <KnowledgeProgress /> */}
              {/* Knowlege version 2 */}
              <KnowledgeProgressV2/>
                {/* <KnowledgeLatestPrograms /> */}
                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="7">
                            <KnowledgeMonthlyPoints />
                        </UiCol>
                        <UiCol lg="5" className="sb-photo-area-kn">
                            {/* <KnowledgePhotos /> */}

                            {/* Knowlege version 2 */}
                            <UiContentCol>
                                <UiCardTitle title="Latest Updates" fullyUnderlined={true} />
                                <PostCard 
                                    profileName="James Roth" 
                                    status="2d.Public" 
                                    content="James has earned 2 new badges!
                                    James completed this task within 15 hours and 25 mins." 
                                    comments="2" 
                                    shares="3"/>
                                <PostCard 
                                    profileName="James Roth" 
                                    status="2d.Public" 
                                    content="James has earned 2 new badges!
                                    James completed this task within 15 hours and 25 mins." 
                                    comments="2" 
                                    shares="3"/>
                                
                            </UiContentCol>

                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <KnowledgeHowToEarn />
                <Footer />
            </UiMainWrapper>
        </>
            )
        
}